export const InlineLoading = (props: {
    visible?: boolean
    size?: string
    centered?: true
    type?: string
    color?: string
}) => {
    if (props.visible === false) {
        return null
    }

    const { size = 'lg', type = 'ring', color = '' } = props

    if (props.centered) {
        return (
            <div className="flex items-center justify-center">
                <span
                    className={`loading loading-${type} loading-${size}`}
                ></span>
            </div>
        )
    }

    return (
        <span
            className={`loading loading-${type} loading-${size} !text-${color}`}
        ></span>
    )
}
